<template>
  <div>
    <div class="selected-label">
      <h3>{{ $t(confirmTitle) }}</h3>
    </div>
    <div class="form form--sidepanel">
      <div class="form-group">
        <p>{{ $t(confirmMessage, [label]) }}</p>
        <p v-if="requiresPrompt" class="alert alert-danger"><i class="fas fa-exclamation-triangle"></i> {{ dangerMessage }}</p>
        <password-prompt v-if="requiresPrompt" ref="prompt" @isValid="(val)=> isValid(val)" :authAction="authAction"/>
        <div class="form-tag flex">
          <button v-if="onCancel" type="button" class="btn btn-default mt20" style="width: 25%" @click="onCancel">{{ $t('messages.confirm_delete.' + confirmCancelButtonLabel) }}</button>
          <button type="submit" class="btn btn-danger mt20" :class="{ml30: !!onCancel}" :disabled="requiresPrompt && (!passwordValid || validating)" style="width: 25%" @click="handleSubmit">
            <i v-if="validating" class="fas fa-spinner rotate" ></i>
            {{ $t('messages.confirm_delete.' + confirmDeleteButtonLabel) }}
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import PasswordPrompt from './password-prompt';
  export default {
    props: {
      title: {
        type: String,
        default: ''
      },
      message: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      deleteButtonLabel: {
        type: String,
        default: 'delete'
      },
      cancelButtonLabel: {
        type: String,
        default: 'cancel'
      },
      bulk: {
        type: Boolean,
        default: false
      },
      requiresPrompt: {
        type: Boolean,
        default: false
      },
      onDelete: {
        type: Function
      },
      onCancel: {
        type: Function
      },
      authAction: {
        type: String
      }
    },
    components: {
      PasswordPrompt
    },
    data() {
      return {
        validating: false,
        passwordValid: false
      }
    },
    methods: {
      isValid (val) {
        this.passwordValid = val;
      },
      isValidating(val) {
        this.validating = val;
      },
      async handleSubmit() {
        try {
          this.validating = true;
          if(this.$props.requiresPrompt)
            await this.$refs.prompt.validate();
          this.$props.onDelete();
        } catch (error) {
          Vue.notify({
            group: "store_notifications",
            type: "error",
            text: this.$t("messages.confirm_delete.password_confirm_error")
          })
        } finally {
          this.validating = false;
        }
      }
    },
    computed: {
      confirmTitle() {
        return this.title ? this.title : 'messages.confirm_delete.title' + (this.bulk ? '_selected' : '')
      },
      confirmMessage() {
        return this.message ? this.message : 'messages.confirm_delete.message'
      },
      confirmDeleteButtonLabel() {
        return this.deleteButtonLabel ? this.deleteButtonLabel.toLowerCase() : 'delete';
      },
      confirmCancelButtonLabel() {
        return this.cancelButtonLabel ? this.cancelButtonLabel.toLowerCase() : 'cancel';
      },
      dangerMessage() {
        const total =  parseInt(this.label.replace( /\D/g, ''));
        if(total > 1) return this.$t("messages.confirm_delete.danger_message_plural", [this.label]);
        return this.$t("messages.confirm_delete.danger_message_singular", [this.label]);
      }
    }
  }
</script>